import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../../shared/services/common/dialog/dialog.service';

declare var $: any;

@Component({
  selector: 'app-dialog-success',
  templateUrl: './dialog-success.component.html',
  styleUrls: ['./dialog-success.component.scss']
})
export class DialogSuccessComponent implements OnInit {

	message: string;

	constructor(
		public dialogService: DialogService
	) {
		dialogService.successAlert$.subscribe(message => {
			this.message = message;

			$('#success-modal').modal('show');
		});
	}

	ngOnInit() {
	}

	onEnter() {
		$('#success-modal').modal('hide');
	}
}
